import React from "react";
import ReactDOM from "react-dom";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import { theme } from "./theme";

const contents: {
  [key: string]: {
    message: string;
    cancel: string;
    confirm: string;
  };
} = {
  default: {
    message: "You're about to leave the page",
    cancel: "Cancel",
    confirm: "Confirm",
  },
  cancel_request: {
    message:
      "Data will be removed, are you sure you want to cancel the request?",
    cancel: "No",
    confirm: "Yes, cancel request",
  },
};

export function Confirm(key: string, callback: (ok: boolean) => void): void {
  const host = document.createElement("div");
  const { message, cancel, confirm } = contents[key] || contents.default;

  function close(status: boolean): void {
    ReactDOM.unmountComponentAtNode(host);
    callback(status);
  }

  document.body.appendChild(host);
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <Dialog fullWidth maxWidth="sm" open onClose={() => close(false)}>
        <DialogContent dividers>
          <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => close(false)}>
            {cancel}
          </Button>
          <Button onClick={() => close(true)}>{confirm}</Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>,
    host
  );
}
